module.exports = __webpack_public_path__ + "img/document-nothing-2.54d499fc.svg";